module.exports = __webpack_public_path__ + "static/media/vietname.5566bd0a.svg";